import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { Router, RouterModule } from '@angular/router';
@Component({
  selector: 'franbase-footer',
  standalone: true,
  imports: [CommonModule, SvgIconComponent, RouterModule],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  router = inject(Router);

  // start::dummy data
  dummyData = [
    {
      key: 'Company',
      items: [
        { key: 'About us', link: '/about-us' },
        { key: 'Careers', link: '/' },
        { key: 'Press', link: '/' },
        { key: 'Contact', link: '/contact' }]
    },
    {
      key: 'Franchise listing',
      items: [
        { key: 'Submit a franchise', link: '/submit-franchise' },
        { key: 'Claim a franchise', link: '/' },
        { key: 'Advertise', link: '/advertise' }]
    },
    {
      key: 'Resources',
      items: [
        { key: 'Learning center', link: '/resources' },
        { key: 'Privacy policy', link: '/privacy-policy' },
        { key: 'Terms & conditions', link: '/term-conditions' },
        { key: 'Site map', link: '/' }] },
    {
      key: 'Popular Searches',
      items: [
        { key: 'New Franchises', link: '/' },
        { key: 'Franchises For Veterans', link: '/' },
        { key: 'Franchises Under $10,000', link: '/' },
        { key: 'Low Cost Franchises', link: '/' },
        { key: 'Accountancy & Financial', link: '/' },
        { key: 'Franchises Under $20,000', link: '/' },
        { key: 'Green Franchises', link: '/' },
        { key: 'Food Franchises', link: '/' },
        { key: 'Franchises Under $50,000', link: '/' },
        { key: 'Master Franchises', link: '/' },
        { key: 'Health & Beauty', link: '/' },
        { key: 'Franchises Under $100,000', link: '/' },
      ],
    },
  ];
  // end::dummy data
}
